import { formatDateTimeForBackend } from "@/plugins/dateUtils";

export function buildManualTripPayload(formData) {
  return {
    ...formData,
    weight: formData.weight || 0,
    volume: formData.volume === "" || formData.volume == null
      ? null
      : Number(formData.volume),
    stops: (formData.stops || []).map(stop => ({
      ...stop,
      datetime_in_place: formatDateTimeForBackend(stop.datetime_in_place || ""),
    })),
  };
}
